package one.healthium.meal_plans.domain

import one.healthium.loco.LString

data class MealPlanInfoModel(
    val id: String,
    val name: LString,
    val tags: List<String>,
) {
    companion object {
        const val PERSONAL_ID = "personal_meal_plan"
    }
}
